import { StringMap } from './types';

export const RANKS_MAP: StringMap = {
    ace: 'a',
    two: '2',
    three: '3',
    four: '4',
    five: '5',
    six: '6',
    seven: '7',
    eight: '8',
    nine: '9',
    ten: '10',
    knight: 'kn',
    jack: 'j',
    queen: 'q',
    king: 'k',
};
export const SUITS: string[] = ['spades', 'hearts', 'clubs', 'diamonds'];
export const COLORS: string[] = ['red', 'black', 'white'];
export const JOKER_IDS: string[] = ['rj', 'wj', 'bj'];
export const OF: string = 'of';
export const JOKER: string = 'joker';
